import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('userDaysStatModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/userDaysStat/reducers/static/combineRegistry.js